<template>
  <div class="main-panel wheel-panel">
    <h2>{{ grandprizes[0].prizes[countIdx].name }}</h2>
    <h1>Rp {{ grandprizes[0].prizes[countIdx].nominal }}</h1>
    <div class="show-options-container">
      <a href="#" class="button mainPink" @click.prevent.stop="displayOptions"
        >Options</a
      >
    </div>

    <div class="show-records-container">
      <a href="#" class="button" @click.prevent.stop="displayRecords"
        >Records</a
      >
    </div>

    <transition name="fade">
      <RecordsPanel v-if="showRecords" @close="hideRecords" />
    </transition>

    <div class="wheel-panel-content">
      <!-- <div class="wheel-header-area">
        <div class="wheel-header" :style="{ width: headerWidth + 'px' }">
          <div class="wheel-header-title">{{ name }}</div>
        </div>
      </div> -->
      <div class="btn-position">
        <v-btn
          height="140px"
          width="140px"
          fab
          class="rounded-button mainPink"
          style="color: #fff; font-size: 1.2rem; font-weight: 800"
          @click.prevent="startSpin"
        >
          {{ spinText }}
        </v-btn>
      </div>

      <Wheel ref="wheel" @result="spinCompleted" />

      <div class="wheel-footer-area">
        <div class="wheel-footer">
          <lottie-animation
            ref="anim"
            :animationData="require('../../assets/lottie-confetti.json')"
            :loop="true"
            class="lottie-container"
          />
          <div class="img-frame">
            <!-- <v-img
            src="http://placehold.it/400x400"
            max-height="300"
            max-width="200"
            class="img-card"
            /> -->

            <div class="wheel-result" v-html="resultText"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecordsPanel from "./RecordsPanel";
import Wheel from "./Wheel";
import { mapGetters, mapState } from "vuex";

import LottieAnimation from "lottie-web-vue";
import { useSound } from "@vueuse/sound";
import spinSfx from "../../assets/spin-sound.mp3";
import winSfx from "../../assets/win-sound.mp3";

export default {
  name: "WheelPanel",
  components: {
    RecordsPanel,
    Wheel,
    LottieAnimation,
  },
  data() {
    return {
      showRecords: false,
      spinning: false,
      spinText: "Spin!",
      resultText: "Ready. Get set.",
      lottieOptions: {
        autoplay: false,
        minimizable: false,
        playerSize: "minimal",
        backgroundColor: "#fff",
        backgroundStyle: "color",
        theme: {
          controlsView: "standard",
          active: "light",
          light: {
            color: "#3D4852",
            backgroundColor: "#fff",
            opacity: "0.7",
          },
          dark: {
            color: "#fff",
            backgroundColor: "#202020",
            opacity: "0.7",
          },
        },
      },
      prizeData: {},
      prizesIndex: 0,
      winners: [],
      countIdx: 0,
    };
  },
  setup() {
    const spinSound = useSound(spinSfx, { volume: 0.5 });
    const winSound = useSound(winSfx, { volume: 0.5 });
    return {
      spinSound,
      winSound,
    };
  },
  created() {
    this.$store.dispatch("fetchDataKado");
    this.$store.dispatch("getGrandprize");
  },
  mounted() {
    // this.$store.dispatch('getPersonDoorprize')
    this.prizeData = this.grandprizes;
    this.$refs.anim.stop();
    this.prizesIndex = this.$route.params.index;

    // if (this.prizeData) {
    //   this.$store.commit('SET_GRANDPRIZE', this.prizeData) //hanya set dari params, tidak dari api
    // }
    // console.log(this.grandprizes, "<< prize data di spinwheel")
  },
  computed: {
    ...mapState({
      spins: (state) => state.spinWheel.spins,
      name: (state) => state.spinWheel.data.name || "Wheel of Fortune",
      winningText: (state) =>
        state.spinWheel.data.winningText || "Congratulations <b>%s</b> !",
      background: (state) => state.spinWheel.data.background || "",
      grandprizes: (state) => state.spinWheel.grandprizes,
      prizes: (state) => state.spinWheel.person,
      headerWidth: (state) => state.spinWheel.size,
      grandprize: (state) => state.spinWheel.gifts,
    }),
    ...mapGetters(["getAvailPersonGp", "modifiedPreset"]),
  },
  methods: {
    displayRecords() {
      this.showRecords = true;
    },

    // Called by the Options button. Shows the options panel.
    displayOptions() {
      if (!this.spinning) {
        this.$store.commit("showOptions");
      }
    },

    hideRecords() {
      this.showRecords = false;
    },

    // Called when the Wheel has stopped spinning.
    spinCompleted(index) {
      this.$refs.anim.play();
      const prize = this.prizes[index];
      // console.log(this.modifiedPreset[index], "<< prize data")
      this.winners.push(this.modifiedPreset[index].userId);
      this.spinning = false;
      this.lottieOptions.autoplay = true;
      this.spinText = "Spin again!";
      this.resultText = this.winningText.replace(
        "%s",
        this.modifiedPreset[index].name
      );
      // setInterval(this.prizes.splice(index, 1), 3000)
      this.$store.dispatch(
        "postWinnersGrandprize",
        this.modifiedPreset[index].userId
      );
      setTimeout(() => {
        this.$store.commit("removePrize", this.index);
        this.countIdx++;
        if (this.winners.length === 3) {
          this.winners.push(this.modifiedPreset[0].userId);
          this.$store.dispatch(
            "postWinnersGrandprize",
            this.modifiedPreset[0].userId
          );
          this.$store.dispatch("postWinnersGrandprize", this.winners);
        }
        // console.log(this.winners, "<< current winners")
        // this.modifiedPreset.splice(index, 1)
      }, 3000);
      if (this.prizes.length <= 0) {
        // this.$store.dispatch('fetchDataKado')
        this.winners.push(this.modifiedPreset[index].userId);
        // console.log(this.modifiedPreset)
      }
      // console.log(this.prizes, index, this.$store.state.spinWheel.preset,"<hasil akhir")
      this.winSound.play();
      // console.log(this.lottieOptions.autoplay, "<< autoplay")
    },

    // Called by the Spin button. Requests the Wheel to start spinning.
    startSpin() {
      console.log(this.getAvailPersonGp, "< avail person");

      if (!this.spinning) {
        this.$store.commit("updateAvailable");
        if (this.prizes.length === 0) return;
        this.spinning = true;
        this.lottieOptions.autoplay = false;
        this.spinText = "Spinning...";
        this.resultText = "&#8203;";
        this.$refs.wheel.startSpin();
        this.$refs.anim.stop();
        this.spinSound.play();
      }
    },
  },
};
</script>

<style>
.btn-position {
  position: absolute;
  display: flex;
  width: calc(100% - 61.3vw);
  height: 100%;
  left: calc(100% - 90.6vw);
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.spin-text {
  color: #f1f4f9;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  border-radius: 100%;
  display: inline-block;
  padding: 3px 9px;
  max-width: 120px;
  border-radius: 100%;
  transition: background-color 0.2s, color 0.2s;
}

.wheel-panel-content {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  z-index: 2;
}
.wheel-header-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 0 0 auto;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  background-color: rgba(241, 244, 249, 0.3);
}
.wheel-header {
  margin: 12px;
  min-width: 300px;
}
.wheel-header-title {
  display: inline-block;
  border-radius: 3px;
}
.wheel-footer-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40vw;
}

.lottie-container {
  position: absolute;
  z-index: 2;
  top: calc(100% - 88vh);
  right: calc(100% - 86vw);
}

.img-frame {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  padding: 12px;
  width: 280px;
  height: 300px;
}
.wheel-footer-area .img-card {
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.wheel-footer {
  padding: 12px;
  font-size: 18px;
  border-radius: 3px;
}
.wheel-result {
  margin-top: 20px;
  margin-bottom: 6px;
  font-size: 36px;
  font-weight: 800;
}
.background-image {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
}
.show-options-container {
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 3;
}
.show-records-container {
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 3;
}
</style>
